"use strict";
// Cleaned



//////////////////
// WEBPACK FOOTER
// ./src/typescript/index.ts
// module id = 0
// module chunks = 0